import { Loadable } from 'foundations-components/transitional/utils/Loadable';
export default Loadable({
  loader: () => import( /* webpackChunkName: "archive-modal" */'./ArchiveModal').then(mod => mod.default),
  LoadingComponent: () => null
});